import React from "react";
import Section from "../Section";
import { Projects } from "../../Data/Data";
import { Link, useNavigate } from "react-router-dom";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";

const SectionProjectsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Section bg={"bg-inherit"}>
      <div className="col-span-10 col-start-2 text-primary-dark">
        <h2 className="font-gilroy text-4xl xl:text-6xl tracking-wider col-span-11 py-8 xl:py-24 leading-4">
          პროექტები
        </h2>

        <div
          className={`flex items-center justify-around gap-4 overflow-x-auto xl:overflow-auto snap-x snap-mandatory scroll-smooth scrollbar-hide py-4 xl:py-12 w-full`}
        >
          {Projects.map((project, index) => (
            <div
              key={index + Math.random()}
              className="bg-black h-full w-full xl:h-[500px] xl:w-[500px] flex-shrink-0 cursor-pointer group relative overflow-hidden transition-all transform duration-500 ease-in-out rounded-3xl "
              onClick={() =>
                delayNavigation(dispatch, navigate, `/projects/${project.name}`)
              }
            >
              <img
                src={project.herroImg}
                alt={`Gallery ${index + 1}`}
                className="h-full group-hover:h-[570px] min-w-full group-hover:w-[570px] opacity-90 group-hover:opacity-70  object-cover object-center duration-500 ease-in-out transform rounded-3xl"
              />
              {/* <h4 className="absolute top-8 xl:top-20 left-10 text-primary-orange  text-xl xl:text-3xl xl:font-gilroy tracking-wider">
                {project.label}
              </h4> */}
              <div className="text-xs lg:text-xl absolute bottom-4 left-10 lg:bottom-12 w-max text-primary-light font-semibold tracking-widest group">
                <Link
                  to={`/projects/${project.name}`}
                  onClick={(event) => {
                    delayNavigation(
                      dispatch,
                      navigate,
                      `/projects/${project.name}`,
                      event
                    );
                  }}
                >
                  {project.label} დეტალებში
                </Link>
                <span className="hidden lg:absolute bottom-0 left-0 w-0 h-[3px] bg-primary-bg-green  transition-all duration-500 group-hover:w-full"></span>
              </div>
              <h4 className="xl:hidden group-hover:block absolute left-10 bottom-8 lg:bottom-24 transform transition-all animate-fadeIn duration-300  text-primary-light font-semibold tracking-widest text-xs lg:text-xl xl:font-extrabold">
                {project.address}
              </h4>
            </div>
          ))}
          {/* <div
            key={2}
            className="bg-black h-full w-full xl:h-[500px] xl:w-[500px] flex-shrink-0 cursor-pointer group relative overflow-hidden transition-all transform duration-500 ease-in-out rounded-3xl"
          >
            <img
              src={Logo}
              alt={`Gallery ${1}`}
              className="h-full group-hover:h-[570px] w-full group-hover:w-[570px]  opacity-50  object-cover object-center shadow-lg duration-500 ease-in-out transform"
            />
            <h4 className="absolute top-8 left-8 text-primary-light  text-3xl font-extrabold">
              coming soon ...
            </h4>
            <h4 className="xl:hidden group-hover:block absolute left-8 bottom-12 lg:bottom-24 transform transition-all animate-fadeIn duration-300  text-primary-light text-sm lg:text-xl font-extrabold">
              ახალი პროექტი K2 ...
            </h4>
          </div> */}
        </div>
        <div className="h-[2px] bg-black opacity-30 my-4" />
      </div>
    </Section>
  );
};

export default SectionProjectsList;
